export const quotationPopup = {
  expirationDay: 30
};

export const productPopup = {
  expirationDay: 30
};
